export const aiAnalytics = {
  title: "AI Analytics",
  description: "Elemezd az adataidat AI segítségével",
  metrics: {
    visitors: "Látogatók",
    sales: "Eladások",
    revenue: "Bevétel",
    conversionRate: "Konverziós arány"
  },
  timeframe: {
    label: "Időszak",
    last7days: "Utolsó 7 nap",
    last30days: "Utolsó 30 nap",
    last90days: "Utolsó 90 nap",
    thisYear: "Idei év"
  },
  chat: {
    title: "AI Elemző Asszisztens",
    placeholder: "Kérdezz az adataidról...",
    examples: {
      title: "Példa kérdések:",
      question1: "Melyik termék teljesít a legjobban?",
      question2: "Milyen trendeket látsz az eladásokban?",
      question3: "Mikor van a legtöbb látogató?",
      question4: "Hogyan javíthatnám a konverziót?"
    }
  },
  charts: {
    visitorsOverTime: "Látogatók időben",
    salesByProduct: "Eladások termék szerint",
    revenueOverTime: "Bevétel időben",
    trafficSources: "Forgalom forrásai"
  },
  button: {
    analyze: "Elemzés",
    export: "Exportálás",
    refresh: "Frissítés"
  }
};
